module.exports = __webpack_public_path__ + "img/3637325.svg";